/**
 * カスタムお問い合わせフォーム用JavaScript
 * 郵便番号検索機能を提供
 */

/**
 * 郵便番号から住所を検索して自動入力する
 */
function searchAddress() {
  // 郵便番号の入力値を取得
  const postalCode = document.getElementById('contact-postal').value;
  
  // ハイフンを削除
  const cleanedPostalCode = postalCode.replace(/-/g, '');
  
  // 郵便番号の形式チェック（7桁の数字）
  if (!/^\d{7}$/.test(cleanedPostalCode)) {
    alert('郵便番号は7桁の数字で入力してください。（例: 1000001 または 100-0001）');
    return;
  }
  
  // zipcloud APIを使用して住所を検索
  const apiUrl = `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${cleanedPostalCode}`;
  
  fetch(apiUrl)
    .then(response => response.json())
    .then(data => {
      if (data.status === 200 && data.results) {
        const result = data.results[0];
        
        // 都道府県を設定
        const prefectureSelect = document.getElementById('contact-prefecture');
        prefectureSelect.value = result.address1;
        
        // 市区町村を設定
        const cityInput = document.getElementById('contact-city');
        cityInput.value = result.address2;
        
        // 町域を設定
        const townInput = document.getElementById('contact-town');
        townInput.value = result.address3;
        
        // 以降の住所にフォーカスを移動
        document.getElementById('contact-address').focus();
      } else {
        alert('該当する住所が見つかりませんでした。郵便番号をご確認ください。');
      }
    })
    .catch(error => {
      console.error('住所検索エラー:', error);
      alert('住所の検索中にエラーが発生しました。しばらくしてから再度お試しください。');
    });
}

/**
 * フォーム送信処理
 * ボタンをtype="button"にしてクリックイベントで完全制御することで
 * defer/DOMContentLoaded のタイミング問題やテーマJSの干渉を回避する
 */
function initContactForm() {
  // URLパラメータに基づいてお問い合わせ種別を初期選択
  const urlParams = new URLSearchParams(window.location.search);
  const typeParam = urlParams.get('type');

  if (typeParam === 'join') {
    const joinRadio = document.querySelector('input[name="contact[お問い合わせ種別]"][value="加入申し込み"]');
    if (joinRadio) joinRadio.checked = true;
  } else if (typeParam === 'other') {
    const otherRadio = document.querySelector('input[name="contact[お問い合わせ種別]"][value="その他お問い合わせ"]');
    if (otherRadio) otherRadio.checked = true;
  }

  const form = document.querySelector('.contact-custom-form');
  if (!form) return;

  const submitBtn = form.querySelector('.submit-btn');
  if (!submitBtn) return;

  submitBtn.addEventListener('click', function() {
    // 1. HTML5ネイティブバリデーション（requiredなど）を実行・表示
    if (!form.reportValidity()) return;

    // 2. 加入申し込みを選択している場合、住所を必須にする
    const inquiryType = document.querySelector('input[name="contact[お問い合わせ種別]"]:checked');
    if (inquiryType && inquiryType.value === '加入申し込み') {
      const postalCode = document.getElementById('contact-postal').value;
      const prefecture = document.getElementById('contact-prefecture').value;
      const city = document.getElementById('contact-city').value;
      const town = document.getElementById('contact-town').value;
      const address = document.getElementById('contact-address').value;

      if (!postalCode || !prefecture || !city || !town || !address) {
        alert('加入申し込みの場合、住所は必須項目です。すべての住所フィールドを入力してください。');

        if (!postalCode) {
          document.getElementById('contact-postal').focus();
        } else if (!prefecture) {
          document.getElementById('contact-prefecture').focus();
        } else if (!city) {
          document.getElementById('contact-city').focus();
        } else if (!town) {
          document.getElementById('contact-town').focus();
        } else if (!address) {
          document.getElementById('contact-address').focus();
        }
        return;
      }
    }

    // 3. チェックボックスグループの値を収集してhidden inputに格納
    // （Shopify contactフォームは配列表記 [] をサポートしないため）
    const checkboxGroups = {};
    form.querySelectorAll('input[type="checkbox"][data-contact-group]:checked').forEach(function(checkbox) {
      const group = checkbox.getAttribute('data-contact-group');
      if (!checkboxGroups[group]) checkboxGroups[group] = [];
      checkboxGroups[group].push(checkbox.value);
    });

    // 既存のhidden inputを削除して重複を防ぐ
    form.querySelectorAll('input[type="hidden"][data-checkbox-hidden]').forEach(function(input) {
      input.remove();
    });

    // 各グループをカンマ区切りでhidden inputとして追加
    Object.keys(checkboxGroups).forEach(function(group) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'contact[' + group + ']';
      hiddenInput.value = checkboxGroups[group].join('、');
      hiddenInput.setAttribute('data-checkbox-hidden', 'true');
      form.appendChild(hiddenInput);
    });

    // 4. フォームを送信（form.submit() はsubmitイベントを発火しないため
    //    テーマJSや他のリスナーの干渉を受けず確実に送信できる）
    form.submit();
  });
}

// DOMContentLoaded済みかどうかに関わらず確実に初期化する
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactForm);
} else {
  initContactForm();
}